import { useMemo, useState } from 'react'
import styles from './Manage.section.module.css'
import SearchInput from '@/features/erp/components/inputs/search/SearchInput'
import { useNavigate } from 'react-router'
import { Files, UsersRound } from 'lucide-react'
import ProvidersList from './components/views/lists/providers/ProvidersList'
import {useProviders} from '../../hooks/providers/useProviders'
import { useCompliances } from '../../hooks/compliances/useProviders'
import CompliancesList from './components/views/lists/compliances/CompliancesList'
import Fuse from 'fuse.js'


export default function ManageSection() {
    const navigate = useNavigate()
    
    //const [design, setDesign] = useState("table")
    const [view, setView] = useState<"providers" | "compliances">("providers")
    
    const { isLoading : isProvidersLoading, data: providers } = useProviders({enabled: view === "providers"})
    const { isLoading: isCompliancesLoading, data: compliances } = useCompliances({enabled: view === "compliances"})
    

    const [search, setSearch] = useState('');

   const fuseProviders = useMemo(() => {
        if (!providers || providers.length === 0) return null;
        return new Fuse(providers, {
            keys: ['name', 'status'],
            threshold: 0.3
        });
    }, [providers]);

    const fuseCompliances = useMemo(() => {
        if (!compliances || compliances.length === 0) return null;
        return new Fuse(compliances, {
            keys: ['provider', 'status'],
            threshold: 0.3
        });
    }, [compliances]);

    
    const providersResults = useMemo(() => {
        if (!providers) return [];
        if (!search || view !== "providers") return providers;
        return fuseProviders?.search(search).map(r => r.item) || providers;
    }, [providers, search, view, fuseProviders]);

    const compliancesResults = useMemo(() => {
        if (!compliances) return [];
        if (!search || view !== "compliances") return compliances;
        return fuseCompliances?.search(search).map(r => r.item) || compliances;
    }, [compliances, search, view, fuseCompliances]);

    return (
        <section className={styles.section}>              
            <div className={styles.actions}>                
                <div className={styles.search}>
                    <SearchInput value={search} setValue={setSearch} placeholder={'Buscar tercero...'} />
                </div>                
                <div className={styles.views}>
                    {/**
                        <div className={styles.designs}>
                            <div 
                                onClick={() => setDesign('table')}
                                className={`${styles.design} ${design === "table" ? styles.active : ''}`}
                            >
                                <Menu />                            
                            </div>
                            <div 
                                onClick={() => setDesign('cards')}
                                className={`${styles.design} ${design === "cards" ? styles.active : ''}`}
                            >
                                <Grid2x2Icon />                                               
                            </div>
                        </div>                     
                     */}
                    <div className={styles.designs}>
                        <div 
                            onClick={() => setView('providers')}
                            className={`${styles.design} ${view === "providers" ? styles.active : ''}`}
                        >
                            <UsersRound />                            
                            <span>Proveedores</span>
                        </div>
                        <div 
                            onClick={() => setView('compliances')}
                            className={`${styles.design} ${view === "compliances" ? styles.active : ''}`}
                        >
                            <Files  />      
                            <span>Cumplimiento</span>                                         
                        </div>
                    </div>
                </div>
                <div className={styles.filter}>

                </div>
                <button 
                    className={styles.add}
                    onClick={() => navigate('creation')}
                >
                    Añadir un tercero
                </button>                
            </div>                           
            <div className={styles.infosection}> 
                { view === "providers" &&       
                    <ProvidersList onGoToCompliances={(provider: string) => {setSearch(provider); setView("compliances")}} data={providersResults} />
                }
                { view === "compliances" &&       
                    <CompliancesList onGoToProviders={(provider: string) => {setSearch(provider); setView("providers")}} data={compliancesResults}/>
                }

                { isProvidersLoading || isCompliancesLoading && <span className={styles.loading}> Cargando... </span> }                
            </div>
        </section>
    )
}
